
  import '/opt/buildhome/repo/docs/playground/copilot.en-US.md?watch=parent';
  export const texts = [];
  